export const REGEXPS = {
    EMAIL: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$',
} as const;

export type RegExpKey = keyof typeof REGEXPS;
export type RegExpPattern = (typeof REGEXPS)[RegExpKey];

export const REGEXP_EMAIL = REGEXPS.EMAIL;
